import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What does Lighthouse AI actually do?',
  answer: 'Lighthouse is an Automated Hiring System (AHS) that screens applications, conducts AI-powered phone screens, and moves qualified candidates through your hiring funnel — all autonomously. It runs 24/7 so you never miss a qualified driver, even while your team is off the clock.'
}, {
  question: 'When will Lighthouse AI be available?',
  answer: "We're currently onboarding early access partners. Join the waitlist and we'll reach out as spots open up — early signups get priority access and founding member pricing."
}, {
  question: 'How is this different from a regular ATS?',
  answer: 'A traditional ATS is essentially a database — it stores applications, but requires a human to take action at every single step. Lighthouse is an Automated Hiring System (AHS), meaning candidates are assessed and moved through your hiring funnel autonomously. The result? Your team saves hundreds of hours of manual effort every month.'
}, {
  question: 'Will this replace my recruiting team?',
  answer: 'No. Lighthouse is built to enhance your recruitment team and allow them to be substantially more effective in their day-to-day activities. By handling the repetitive, time-consuming work — screening, phone calls, scheduling — your recruiters can be up to 5x more productive and focus on closing the best candidates.'
}, {
  question: 'What size fleets is this built for?',
  answer: 'Lighthouse is designed for fleets of all sizes, from owner-operators hiring their first few drivers to large carriers managing hundreds of seats. The AI scales with your hiring volume, so it works just as well for 5 hires a month as it does for 500.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-27">
            Common Questions
          </h2>
          <p className="text-lg text-slate-600" data-id="element-28">
            Everything you need to know before joining the waitlist.
          </p>
        </motion.div>

        <div className="space-y-3" data-id="element-29">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-30">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-slate-50 transition-colors" data-id="element-31">
                  <span className="font-display font-semibold text-slate-900 pr-4" data-id="element-32">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="flex-shrink-0" data-id="element-33">
                    <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-34" />
                  </motion.div>
                </button>
                <AnimatePresence initial={false} data-id="element-35">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-36">
                      <p className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-37">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}